module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pshou13-0c2893c9e97071f5b5096d71317ecf69.jpg";